import store from '../../store';

export default class AgentScrollerService {
  /**
   * Elements to reduce height from
   * start property can be used to add additional height to subtract from containers
   */
  static cSelectors = {
    matches: {
      externalHeader: parseFloat(APP_SETTINGS.settings.scrollerStartHeight) || 0,
      start: 0,
      agentHeader: 0,
      topNav: 0,
      fixtureMenu: 0,
      searchFilter: 0,
      sbSearch: 0,
      prematchNav: 0,
    },
    matchDetails: {
      externalHeader: parseFloat(APP_SETTINGS.settings.scrollerStartHeight) || 0,
      start: 0,
      agentHeader: 0,
      topNav: () => {
        return store.state.GlobalModule.AgentMultiView ? 0 : this.cSelectors.matches.topNav;
      },
      fullTitle: 0,
      matchDetailsFilter: 0
    },
    betslip: {
      externalHeader: parseFloat(APP_SETTINGS.settings.scrollerStartHeight) || 0,
      start: 0,
      agentHeader: 0,
      betslipPlace: 0
    },
    mybets: {
      externalHeader: parseFloat(APP_SETTINGS.settings.scrollerStartHeight) || 0,
      start: 0,
      topNav: () => {
        return this.cSelectors.matches.topNav;
      },
      mybetsMenu: 0,
      mybetsFilter: 0,
    },
    betChecker: {
      externalHeader: parseFloat(APP_SETTINGS.settings.scrollerStartHeight) || 0,
      start: 0,
      topNav: () => {
        return this.cSelectors.matches.topNav;
      },
      betCheckerTitle: 0,
    },
    boostedOdds: {
      externalHeader: parseFloat(APP_SETTINGS.settings.scrollerStartHeight) || 0,
      start: 0,
      agentHeader: 0,
      topNav: () => {
        return this.cSelectors.matches.topNav;
      },
      fixtureMenu: 0,
      searchFilter: 0,
      sbSearch: 0,
    },
  };
  /**
   * Save data for recalculation on windows resize
   * @type {{}}
   */
  static cache = {};
  /**
   * Containers to reducr height from
   * @type {{betslip: string, matches: string}}
   */
  static containers = {
    matches: 'div.prematch-scrollbar',
    matchDetails: 'div.prematch-details-scrollbar',
    betslip: 'div.betslip-scrollbar',
    mybets: '#mybets-scrollbar',
    betChecker: '#betchecker-scrollbar',
    boostedOdds: 'div.bto-sb-widget-boost-bet',
  };

  /**
   * Get element height
   * @param el
   * @returns {number}
   */
  static getElHeight(el) {
    return !el ? 0 : el.getBoundingClientRect().height;
  }

  /**
   * Set scroller height
   * @param s scrolling element
   * @param type
   */
  static setScrollerHeight(s, type) {
    const scrollableC = document.querySelector(s);
    if (typeof APP_SETTINGS.settings.columnScroll === 'undefined' ||
      !APP_SETTINGS.settings.columnScroll ||
      store.state.GlobalModule.isMobile ||
      !scrollableC) {
      return;
    }
    const docBody = document.body;
    let viewportHeight = docBody.getBoundingClientRect().height;
    let totalHeight = 0;
    for (let n in this.cSelectors[type]) {
      const h = this.cSelectors[type][n];
      totalHeight += typeof h === 'function' ? h() : h;
    }
    if (s === 'div.betslip-scrollbar') {
      scrollableC.style.height = `${viewportHeight - totalHeight}px`;
    } else {
      scrollableC.style.maxHeight = `${viewportHeight - totalHeight}px`;
    }
  }

  /**
   * Set element height
   * @param el html element
   * @param k key for selector to set height
   * @param type
   * @param startHeight add here any height you want to subtract from container scroller
   */
  static setElHeight(el = null, k, type = 'matches', startHeight = 0) {
    if (!el || !this.cSelectors.hasOwnProperty(type) || !this.cSelectors[type].hasOwnProperty(k)) {
      return;
    }
    this.cSelectors[type][k] = this.getElHeight(el);

    if (startHeight) {
      this.cSelectors[type].start = startHeight;
    }
    this.setScrollerHeight(this.containers[type], type);
    this.cache[k] = { el, type, startHeight };
  }

  /**
   * Recalculate scrollers height on window resize
   */
  static recalcHeights(s) {
    if (typeof s !== 'undefined' && this.cache.hasOwnProperty(s)) {
      const { el, type, startHeight } = this.cache[s];
      this.setElHeight(el, s, type, startHeight);
      return;
    }
    const keys = Object.keys(this.cache);
    if (!Object.keys(this.cache).length) {
      return;
    }
    keys.forEach((key) => {
      const { el, type, startHeight } = this.cache[key];
      this.setElHeight(el, key, type, startHeight);
    });
  }
}